var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p-auto-complete',_vm._g(_vm._b({attrs:{"placeholder":_vm.option.label,"dropdown":_vm.option.dropdown,"suggestions":_vm.suggestions,"disabled":_vm.disabled,"field":_vm.option.key},on:{"complete":function($event){return _vm.loadData($event)}},model:{value:(_vm.option.value),callback:function ($$v) {_vm.$set(_vm.option, "value", $$v)},expression:"option.value"}},'p-auto-complete',_vm.$attrs,false),{
      ..._vm.$listeners,
    }))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }